// extracted by mini-css-extract-plugin
export default {"popoverContent":"Xj3yp3b2HvA5Uyfd9n9p"};